
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestdealoftheday",
      function () {
        return require("private-next-pages/bestdealoftheday.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestdealoftheday"])
      });
    }
  